// 한주의 데이터를 구하는 함수
export const getWeekDates = () => {
    
    const today = new Date();
    const currentDayIndex = today.getDay();
    const weekStart = new Date(today);
    weekStart.setDate(today.getDate() - currentDayIndex);
    const weekDates = [];

    for (let i = 0; i < 7; i++) {
    const date = new Date(weekStart);
    date.setDate(weekStart.getDate() + i);
    // const dayOfWeek = daysOfWeek[date.getDay()];
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    weekDates.push(formattedDate);
    }
    // console.log(daysOfWeek)
    return weekDates;
};